import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, UserInteractionData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const wasteEvents: KpiHandler = {
  type: 'KpiTile',
  handler: (data: UserInteractionData): KpiData => {
    const { wasteEvents, wasteEventsDelta } = data;

    const formattedValue = formatPercentageValue(wasteEvents);
    const tag = {
      text: formatPercentageValue(Math.abs(wasteEventsDelta)),
      isPositiveValue: wasteEventsDelta >= 0,
    };

    return createKpiTileItem(
      'Waste Events',
      formattedValue,
      wasteEventsDelta ? tag : []
    );
  },
};

export default wasteEvents;
